import loadable from '@loadable/component';
import { OverlaySpinner } from '@ankr.com/ui';

const RawStatisticsPage = loadable(
  async () => {
    const module = await import('./RawStatisticsPage');

    return module.RawStatisticsPage;
  },
  {
    fallback: <OverlaySpinner />,
  },
);

export const RawStatisticsPageContainer = () => <RawStatisticsPage />;
